import React, { Component } from 'react'
import CustomAlert from '../../components/shared/CustomAlert'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import UserEvents from './components/UserEvents/UserEvents.component'
import UserEventStore from './components/UserEvents/UserEvent.store'
import { MDBRow, MDBCol, MDBContainer } from 'mdb-react-ui-kit'
import UserProfileService from './../../shared/services/UserProfile.service'

import './UserEventLog.page.scss'

const ColorLegend = () => {
  return (
    <div className='container-fluid ColorLegendComponent'>
      <MDBRow>
        <MDBCol>
          <CustomAlert color='success'>Success/Passing Outcome</CustomAlert>
        </MDBCol>
        <MDBCol>
          <CustomAlert color='warning'>Notice/Warning Outcome</CustomAlert>
        </MDBCol>
        <MDBCol>
          <CustomAlert color='danger'>Error/Failing Outcome</CustomAlert>
        </MDBCol>
        <MDBCol>
          <CustomAlert color='info'>Significant Event</CustomAlert>
        </MDBCol>
        <MDBCol>
          <CustomAlert color='secondary'>Standard Event</CustomAlert>
        </MDBCol>
      </MDBRow>
    </div>
  )
}

class UserEventLogPage extends Component {
  _fetch = async () => await UserEventStore.init(await UserProfileService.instance())

  componentDidMount() {
    this._fetch()
  }

  render() {
    return (
      <DashboardLayout>
        <main id='UserEventLogPage' className='mainSection pb-5'>
          <MDBContainer fluid className='mt-5'>
            <PageHeading
              label='User History'
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from}
              btnGroup={<ColorLegend />}
            />
          </MDBContainer>
          <MDBContainer className='pb-5'>
            <MDBRow>
              <MDBCol></MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
                <div className='content-wrapper'>
                  <UserEvents />
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default UserEventLogPage
